"use strict"
var Writable = require('stream').Writable
var inherits = require('util').inherits

var DEFAULT_INTERVAL = 1000
var DEFAULT_BUFFER_LENGTH = 120
var intervalUnits = {
  "seconds": 0,
  "minutes": 1,
  "hours": 2,
  "days": 3
}

function TimeSeriesRingBuffer (options) {
  if (!(this instanceof TimeSeriesRingBuffer)) {
    return new TimeSeriesRingBuffer(options)
  }
  Writable.call(this, {objectMode: true})
  options = options || {}
  this.startBufferingAtPosZero = options.startBufferingAtPosZero
  this.interval = options.interval || DEFAULT_INTERVAL
  this.intervalUnit = options.intervalUnit || "seconds"
  this.bufferLength = options.bufferLength || DEFAULT_BUFFER_LENGTH
  this.initBuffer()
}
inherits(TimeSeriesRingBuffer, Writable)

var proto = TimeSeriesRingBuffer.prototype

proto._createDefaultBufferData = function () {
  throw new Error("_createDefaultBufferData not implemented")
}

proto._resetBufferData = function (/*bufferData*/) {
  throw new Error("_resetBufferData not implemented")
}

proto._mergeData = function (/*bufferData, data*/) {
  throw new Error("_mergeData not implemented")
}

proto.initBuffer = function () {
  var len = this.bufferLength
  this.buffer = new Array(len)
  this.bufferPos = -1
  this.latestTimestamp = 0
  var i
  for (i = 0; i < len; i += 1) {
    this.buffer[i] = this._createDefaultBufferData()
  }
}

proto.isEmpty = function () {
  return this.bufferPos < 0
}

proto._write = function (data, enc, next) {
  var bufferPos = this.getBufferPosFromTimestamp(data.timestamp)
  if (bufferPos < 0) { return next() }
  this.updateBufferPosition(bufferPos, data)
  var bufferData = this.getBufferDataAtPos(bufferPos)
  if (bufferData) {
    this._mergeData(bufferData, data)
  }
  next()
}

proto.updateBufferPosition = function (bufferPos, latestData) {
  if (bufferPos <= this.bufferPos) { return }
  var self = this
  var lastPos = this.bufferPos
  this.bufferPos = bufferPos
  this.latestTimestamp = (this.latestTimestamp === 0) ? this.roundTimestamp(latestData.timestamp) : 
    (bufferPos - lastPos) * this.interval + this.latestTimestamp
  var startingPos = Math.max(lastPos + 1, bufferPos - this.bufferLength + 1)
  var numPoints = this.bufferPos - startingPos + 1
  this.fromPositionForNumPoints(startingPos, numPoints, function (bufferData, bufferPos) {
    bufferData.timestamp = self.timestampFromBufferPos(bufferPos)
    self._resetBufferData(bufferData, latestData)
  })
}

proto.getBufferPosFromTimestamp = function (timestamp) {
  if (this.isEmpty()) {
    return this.startBufferingAtPosZero ? 0 : this.bufferLength - 1
  }
  if (timestamp <= this.latestTimestamp - (this.bufferLength * this.interval)) {
    return -1
  }
  return this.bufferPos - Math.ceil((this.latestTimestamp - timestamp) / this.interval)
}

proto.timestampFromBufferPos = function (bufferPos) {
  return this.latestTimestamp - this.interval * (this.bufferPos - bufferPos)
}

proto.roundTimestamp = function (timestamp) {
  var unitScore = intervalUnits[this.intervalUnit] || 0
  var date = new Date(timestamp)
  date.setMilliseconds(0)
  if (unitScore >= 1) {
    date.setSeconds(0)
  }
  if (unitScore >= 2) {
    date.setMinutes(0)
  }
  if (unitScore >= 3) {
    date.setHours(0)
  }
  return date.valueOf()
}

proto.getBufferDataAtPos = function (bufferPos) {
  var index = this.getBufferIndexFromPos(bufferPos)
  if (index < 0) { return null }
  return this.buffer[index]
}

proto.getBufferIndexFromPos = function (bufferPos) {
  if (bufferPos > this.bufferPos || bufferPos <= this.bufferPos - this.bufferLength) {
    return -1
  }
  return bufferPos % this.bufferLength
}

proto.fromPositionForNumPoints = function (startingPosition, numPoints, func) {
  if (this.isEmpty() || startingPosition > this.bufferPos) { return }
  var buffer = this.buffer
  numPoints = Math.min(numPoints, (this.bufferPos - startingPosition + 1))
  var i1 = this.getBufferIndexFromPos(startingPosition)
  var end = i1 + numPoints
  var rollover = end - buffer.length
  if (rollover > 0) { end = buffer.length }

  var currentPos = startingPosition
  var data
  for (i1; i1 < end; i1 += 1) {
    data = buffer[i1]
    if (data) {
      func(data, currentPos)
    }
    currentPos += 1
  }
  if (rollover <= 0) { return }

  var i2
  for (i2 = 0; i2 < rollover; i2 += 1) {
    data = buffer[i2]
    if (data) {
      func(data, currentPos)
    }
    currentPos += 1
  }
}

proto.forNumPoints = function (numPoints, func) {
  this.fromPositionForNumPoints(this.bufferPos - (this.bufferLength - 1), numPoints, func)
}

proto.forLastNumPoints = function (numPoints, func) {
  this.fromPositionForNumPoints(this.bufferPos - (numPoints - 1), numPoints, func)
}

proto.forEach = function (func) {
  this.forNumPoints(this.bufferLength, func)
}

module.exports = TimeSeriesRingBuffer
